<template>
  <div class="container mt-5 px-2">
    <article class="message is-danger" v-if="!token">
      <div class="message-body">
        You have not signed in yet. Please go back to <a href="/">home page</a> to sign in first.
      </div>
    </article>
    <div v-if="token">
      <div>        
        <h1 class="title">Sales Monitor</h1>

        <div class="tabs is-toggle">
          <ul>
            <li :class="{'is-active': country == 'US'}">
              <a @click="country = 'US'">
                <span>US</span>
              </a>
            </li>
            <li :class="{'is-active': country == 'Canada'}">
              <a @click="country = 'Canada'">
                <span>Canada</span>
              </a>
            </li>
          </ul>
        </div>

        <label class="checkbox">
          <input type="checkbox" v-model="showHidden" />
          Show hidden
        </label>

        <div class="mt-3">
          <div v-if="waiting">
            <span class="icon is-medium is-size-4">
              <i class="fas fa-spinner fa-pulse"></i>
            </span>
          </div>
          <div v-else>
            <div class="columns mt-4">
              <div class="column field mb-0 pb-0">
                <p class="control has-icons-left">
                  <span class="select">
                    <select v-model="filter">
                      <option v-for="(c, i) in classOptions"  :key="'product-class-option' + i">
                        {{c}}
                      </option>
                    </select>
                  </span>
                  <span class="icon is-small is-left">
                    <i class="fas fa-filter"></i>
                  </span>
                </p>
              </div>
              <div class="column field  mb-0 pb-0">
                <p class="control has-icons-left">
                  <input class="input" type="text" placeholder="Search" v-model="search">
                  <span class="icon is-small is-left">
                    <i class="fas fa-search"></i>
                  </span>
                </p>
              </div>
            </div>

            <div class="table-container">
              <table class="table is-fullwidth is-hoverable my-table">
                <thead>
                  <th class="is-clickable" @click="changeSortOption('itemId')">
                    <span>Item id</span>
                    <span class="icon" v-if="sortOption.field == 'itemId'">
                      <i class="fas" :class="{'fa-sort-up': sortOption.asc, 'fa-sort-down': !sortOption.asc}"></i>
                    </span>
                  </th>
                  <th class="is-clickable" @click="changeSortOption('itemSku')">
                    <span>SKU / Platform</span>
                    <span class="icon" v-if="sortOption.field == 'itemSku'">
                      <i class="fas" :class="{'fa-sort-up': sortOption.asc, 'fa-sort-down': !sortOption.asc}"></i>
                    </span>
                  </th>
                  <th class="has-text-right is-clickable" @click="changeSortOption(countryPrefix + '.inventory.all')">
                    <span>Inventory</span>
                    <span class="icon" v-if="sortOption.field == countryPrefix + '.inventory.all'">
                      <i class="fas" :class="{'fa-sort-up': sortOption.asc, 'fa-sort-down': !sortOption.asc}"></i>
                    </span>
                  </th>
                  <th class="has-text-right is-clickable" @click="changeSortOption(countryPrefix + '.1w.all.quantity')">
                    <span>One week sales</span>
                    <span class="icon" v-if="sortOption.field == countryPrefix + '.1w.all.quantity'">
                      <i class="fas" :class="{'fa-sort-up': sortOption.asc, 'fa-sort-down': !sortOption.asc}"></i>
                    </span>
                  </th>
                  <th class="has-text-right is-clickable" @click="changeSortOption(countryPrefix + '.1w.all.days')">
                    <span>One week days</span>
                    <span class="icon" v-if="sortOption.field == countryPrefix + '.1w.all.days'">
                      <i class="fas" :class="{'fa-sort-up': sortOption.asc, 'fa-sort-down': !sortOption.asc}"></i>
                    </span>
                  </th>
                  <th class="has-text-right is-clickable" @click="changeSortOption(countryPrefix + '.1w.all.speed')">
                    <span>One week speed</span>
                    <span class="icon" v-if="sortOption.field == countryPrefix + '.1w.all.speed'">
                      <i class="fas" :class="{'fa-sort-up': sortOption.asc, 'fa-sort-down': !sortOption.asc}"></i>
                    </span>
                  </th>
                  <th class="has-text-right is-clickable" @click="changeSortOption(countryPrefix + '.2w.all.quantity')">
                    <span>Two weeks sales</span>
                    <span class="icon" v-if="sortOption.field == countryPrefix + '.2w.all.quantity'">
                      <i class="fas" :class="{'fa-sort-up': sortOption.asc, 'fa-sort-down': !sortOption.asc}"></i>
                    </span>
                  </th>
                  <th class="has-text-right is-clickable" @click="changeSortOption(countryPrefix + '.2w.all.days')">
                    <span>Two week days</span>
                    <span class="icon" v-if="sortOption.field == countryPrefix + '.2w.all.days'">
                      <i class="fas" :class="{'fa-sort-up': sortOption.asc, 'fa-sort-down': !sortOption.asc}"></i>
                    </span>
                  </th>
                  <th class="has-text-right is-clickable" @click="changeSortOption(countryPrefix + '.2w.all.speed')">
                    <span>Two weeks speed</span>
                    <span class="icon" v-if="sortOption.field == countryPrefix + '.2w.all.speed'">
                      <i class="fas" :class="{'fa-sort-up': sortOption.asc, 'fa-sort-down': !sortOption.asc}"></i>
                    </span>
                  </th>
                  <th class="has-text-right is-clickable" @click="changeSortOption(countryPrefix + '.4w.all.quantity')">
                    <span>One month sales</span>
                    <span class="icon" v-if="sortOption.field == countryPrefix + '.4w.all.quantity'">
                      <i class="fas" :class="{'fa-sort-up': sortOption.asc, 'fa-sort-down': !sortOption.asc}"></i>
                    </span>
                  </th>
                  <th class="has-text-right is-clickable" @click="changeSortOption(countryPrefix + '.yearMax.all')">
                    <span>One year max speed</span>
                    <span class="icon" v-if="sortOption.field == countryPrefix + '.yearMax.all'">
                      <i class="fas" :class="{'fa-sort-up': sortOption.asc, 'fa-sort-down': !sortOption.asc}"></i>
                    </span>
                  </th>
                  <th class="has-text-right is-clickable" @click="changeSortOption(countryPrefix + '.speedIncrease.all')">
                    <span>Speed increase rate (%)</span>
                    <span class="icon" v-if="sortOption.field == countryPrefix + '.speedIncrease.all'">
                      <i class="fas" :class="{'fa-sort-up': sortOption.asc, 'fa-sort-down': !sortOption.asc}"></i>
                    </span>
                  </th>
                  <th class="has-text-right is-clickable" @click="changeSortOption(countryPrefix + '.potential.all')">
                    <span>Sales Potential (%)</span>
                    <span class="icon" v-if="sortOption.field == countryPrefix + '.potential.all'">
                      <i class="fas" :class="{'fa-sort-up': sortOption.asc, 'fa-sort-down': !sortOption.asc}"></i>
                    </span>
                  </th>
                  <th class="has-text-right is-clickable" @click="changeSortOption(countryPrefix + '.coverage.all')">
                    <span>Coverage in weeks</span>
                    <span class="icon" v-if="sortOption.field == countryPrefix + '.coverage.all'">
                      <i class="fas" :class="{'fa-sort-up': sortOption.asc, 'fa-sort-down': !sortOption.asc}"></i>
                    </span>
                  </th>
                  <th class="has-text-right is-clickable" @click="changeSortOption(countryPrefix + '.remaining.all')">
                    <span>OOS in days</span>
                    <span class="icon" v-if="sortOption.field == countryPrefix + '.remaining.all'">
                      <i class="fas" :class="{'fa-sort-up': sortOption.asc, 'fa-sort-down': !sortOption.asc}"></i>
                    </span>
                  </th>
                </thead>
                <tbody>
                  <tr v-for="(p, i) in showingItems" :key="'product-' + i">
                    <td :class="{'has-text-weight-bold': p.itemId, 'hover-trigger': !showHidden}">
                      <router-link :to="'/sales-summary/' + p.itemId">{{p.itemId}}</router-link>
                      <button v-if="p.itemId" class="button is-small is-white" :class="{'hover-target': !showHidden}" @click="toggleHidden(p.id)">
                        <span class="icon is-small">
                          <i class="fas" :class="{'fa-eye-slash': p.hidden, 'fa-eye': !p.hidden}"></i>
                        </span>
                      </button>
                    </td>
                    <td :class="{'has-text-weight-bold': p.itemId, 'has-text-right': !p.itemId}">
                      <span>{{p.name}}</span>
                      <span v-if="p.itemId">
                        <button class="button is-small is-white" @click="toggleOpened(p.itemId)">
                          <span class="icon is-small">
                            <i class="fas" :class="{'fa-angle-up': openedMap[p.itemId], 'fa-angle-down': !openedMap[p.itemId]}"></i>
                          </span>
                        </button>
                      </span>
                    </td>
                    <td class="has-text-right" :class="{'has-text-weight-bold': p.itemId}">{{ p.inventory }}</td>
                    <td class="has-text-right" :class="{'has-text-weight-bold': p.itemId}">{{ p.w1.quantity}}</td>
                    <td class="has-text-right" :class="{'has-text-weight-bold': p.itemId}">{{ p.w1.days}}</td>
                    <td class="has-text-right" :class="{'has-text-weight-bold': p.itemId}">{{ roundTo(p.w1.speed, 3)}}</td>
                    <td class="has-text-right" :class="{'has-text-weight-bold': p.itemId}">{{ p.w2.quantity}}</td>
                    <td class="has-text-right" :class="{'has-text-weight-bold': p.itemId}">{{ p.w2.days}}</td>
                    <td class="has-text-right" :class="{'has-text-weight-bold': p.itemId}">{{ roundTo(p.w2.speed, 3)}}</td>
                    <td class="has-text-right" :class="{'has-text-weight-bold': p.itemId}">{{ p.w4.quantity}}</td>
                    <td class="has-text-right" :class="{'has-text-weight-bold': p.itemId}">{{ roundTo(p.year, 3)}}</td>
                    <td class="has-text-right" :class="{'has-text-weight-bold': p.itemId}">{{ p.increase}}</td>
                    <td class="has-text-right" :class="{'has-text-weight-bold': p.itemId}">{{ p.potential}}</td>
                    <td class="has-text-right" :class="{'has-text-weight-bold': p.itemId}">{{ roundTo(p.coverage, 0)}}</td>
                    <td class="has-text-right" :class="{'has-text-weight-bold': p.itemId}">{{ roundTo(p.remaining, 0)}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            
          </div>
        </div>
      </div>
      
      
      <div v-if="error" class="notification is-danger is-light">
        <button class="delete" @click="error=''"></button>
        {{error}}
      </div>
    </div>
  </div>
</template>

<script>
import { Fragment } from 'vue-fragment'

function getFieldValue (obj, path) {
  var ss = path.split('.')
  var value = obj[ss[0]]
  var i = 1
  while (i < ss.length && value) {
    value = value[ss[i]]
    i += 1
  }
  return value
}

export default {
  name: 'SalesMonitor',
  components: {
    Fragment
  },
  data () {
    return {
      error: '',
      waiting: false,
      search: '',
      filter: 'All',
      products: [],
      search: '',
      openedMap: {},
      sortOption: { field: 'itemSku', asc: true },
      country: 'US',
      showHidden: false,
    }
  },
  computed: {
    server () {
      return this.$store.state.config.server
    },
    token () {
      return this.$store.state.user.token
    },
    countryPrefix () {
      return this.country.toLowerCase() + 'Sales'
    },
    showingProducts () {
      var vm = this
      var filtered = this.products.filter(p => {
        if (vm.filter == 'All') {
          return true
        }
        return p.className == vm.filter
      }).filter(p => {
        if (!vm.showHidden && p.hidden) {
          return false
        }
        var search = vm.search.toLowerCase()
        return p.itemId.toLowerCase().includes(search)
          || p.itemSku.toLowerCase().includes(search)
          || p.className.toLowerCase().includes(search)
      })

      var sort = vm.sortOption
      var sorted = filtered.sort((a, b) => {
        var va = getFieldValue(a, sort.field)
        var vb = getFieldValue(b, sort.field)
        if (!va || !vb) {
          if (va) {
            return sort.asc ? 1 : -1
          }
          if (vb) {
            return sort.asc ? -1 : 1
          }
          return 0
        }
        var prefix = vm.country.toLowerCase() + 'Sales.'
        if (sort.field == prefix + 'inventory.all' || sort.field == prefix + '1w.all.quantity' || sort.field == prefix + '1w.all.days' || sort.field == prefix + '1w.all.speed'
            || sort.field == prefix + '2w.all.quantity' || sort.field == prefix + '2w.all.days' || sort.field == prefix + '2w.all.speed' || sort.field == prefix + '4w.all.quantity'
            || sort.field == prefix + 'yearMax.all' || sort.field == prefix + 'speedIncrease.all'  || sort.field == prefix + 'potential.all' || sort.field == prefix + 'coverage.all'
            || sort.field == prefix + 'remaining.all') {
          if (!va || va == 'N/A' || va == '') {
            va = 0
          } else {
            va = parseFloat(va)
          }
          if (!vb || vb == 'N/A' || vb == '') {
            vb = 0
          } else {
            vb = parseFloat(vb)
          }
          return sort.asc ? va - vb : vb - va
        }
        return sort.asc ? va.localeCompare(vb) : vb.localeCompare(va)
      })
      return sorted
    },
    showingItems () {
      var items = []
      this.showingProducts.forEach(p => {
        var mainItem = this.makeItem(p, 'all')
        items.push(mainItem)
        if (this.openedMap[p.itemId]) {
          ['hd', 'wf', 'lowes'].forEach(platform => {
            var pItem = this.makeItem(p, platform)
            items.push(pItem)
          })
        }
      })
      return items
    },
    classOptions () {
      var classNames = new Set()
      this.showingProducts.forEach(p => classNames.add(p.className))
      var classOptions = [...classNames]
      classOptions.sort((a, b) => a.localeCompare(b))
      classOptions.unshift('All')
      return classOptions
    },
  },
  methods: {
    makeItem (p, platform) {
      var platforms = {'hd': 'Home Depot', 'wf': 'Wayfair', 'lowes': 'Lowes'}
      var name = platform == 'all' ? p.itemSku : platforms[platform]
      var itemId = platform == 'all' ? p.itemId : ''
      var prefix = this.country.toLowerCase() + 'Sales'
      var item = {
        id: p.id,
        hidden: p.hidden,
        name: name,
        itemId: itemId,
        inventory: p[prefix]['inventory'][platform],
        w1: p[prefix]['1w'][platform],
        w2: p[prefix]['2w'][platform],
        w4: p[prefix]['4w'][platform],
        year: p[prefix]['yearMax'][platform],
        increase: p[prefix]['speedIncrease'][platform],
        potential: p[prefix]['potential'][platform],
        coverage: p[prefix]['coverage'][platform],
        remaining: p[prefix]['remaining'][platform],
      }
      return item
    },
    getProducts () {
      this.waiting = true
      this.$http.get(this.server + '/myapp/get-sale-summaries/').then(resp => {
        this.products = resp.body
        var openedMap = {}
        for (var p of this.products) {
          openedMap[p.itemId] = false
        }
        this.openedMap = openedMap
        this.waiting = false
      }, err => {
        this.error = err.body
        this.waiting = false
      })
    },
    toggleOpened (itemId) {
      this.openedMap[itemId] = !this.openedMap[itemId]
    },
    changeSortOption (field) {
      this.sortOption = {
        field: field,
        asc: field == this.sortOption.field ? !this.sortOption.asc : false
      }
    },
    roundTo (value, decimals) {
      if (typeof(value) == 'string') {
        return value
      }
      if (!value) {
        return 0
      }
      if (decimals == 0) {
        return Math.round(value)
      }
      var tens = Math.pow(10, decimals)
      return Math.round((value + Number.EPSILON) * tens) / tens
    },
    toggleHidden (id) {
      var message = {summaryId: id}
      this.$http.post(this.server + '/myapp/toggle-summary-hidden/', message).then(resp => {
        this.products.forEach(p => {
          if (p.id == id) {
            p.hidden = !p.hidden
          }
        })
      })
    },
  },
  mounted () {
    this.getProducts()
  },
}
</script>

<style scoped>
.hover-target {
  display: none; /* Initially hides the target element */
}

.hover-trigger:hover .hover-target {
  display: block; /* Shows the target element when the parent is hovered */
}
</style>
